// extracted by mini-css-extract-plugin
export default {"resultContainer":"xC_ck","resultTitle":"xC_xE","container_left":"xC_we","container_right":"xC_wf","leftDice":"xC_wi","rightDice":"xC_wj","container":"xC_gw"};